import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from 'ngx-alerts';
import { NgxSpinnerService } from 'ngx-spinner';
import { DlaService } from 'src/app/shared/dla.service';

@Component({
  selector: 'app-reply-mail',
  templateUrl: './reply-mail.component.html',
  styleUrls: ['./reply-mail.component.css']
})
export class ReplyMailComponent implements OnInit {
  mainPageTitle = 'Replay Message';
  messages: any[];
  userinfo: any;
  messageForm: FormGroup;
  submitted = false;
  mainMessage: string;
  userData: any;
  mail_id: string;
  type = '';
  mail: any = '';

  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute,
    private alertService: AlertService,
    private dlaService: DlaService) {
    this.messageForm = this.formBuilder.group({
      replyTo: ['', Validators.required],
      subject: ['', Validators.required],
      messageBody: ['', Validators.required],
    });
  }

  get f() { return this.messageForm.controls; }

  ngOnInit(): void {
    this.loadScripts();
    this.userData = JSON.parse(localStorage.getItem('dla_student'));


    this.mail_id = this.route.snapshot.paramMap.get('id');

    this.type = this.route.snapshot.paramMap.get('type');

    console.log('Type: ' + this.type);
    console.log('Mail ID: ' + this.mail_id);

    this.getSingleMessage();

    this.userData = JSON.parse(localStorage.getItem('dla_student'));

  }

  getSingleMessage() {
    this.spinner.show();
    this.dlaService.getSingleMail(this.type, this.mail_id).subscribe(
      (data: any) => {
        this.spinner.hide();
        const error: boolean = data.error;
        if (!error) {
          console.log(data);
          this.mail = data;
          this.messageForm.controls["replyTo"].setValue(this.mail.sender);
          this.messageForm.controls["subject"].setValue("Re: " + this.mail.subject);
          this.messageForm.controls["messageBody"].setValue("<br/><br/>--<br/>" + this.mail.body);
          this.mainMessage = "<br/><br/>--<br/>" + this.mail.body;
        } else {
          this.alertService.danger(data.message);
        }
      },
      error => {
        this.spinner.hide();
        this.alertService.danger('An error occurred, Please try again');
      }
    );
  }


  onSubmit() {

    this.submitted = true;

    const textarea = document.getElementsByClassName('note-editable panel-body');

    this.messageForm.controls["messageBody"].setValue(textarea[0].innerHTML);

    // stop here if form is invalid
    if (this.messageForm.invalid) {
      this.alertService.danger("Please fill all required fields");
      return;
    }

    // console.log(this.messageData.id);
    this.spinner.show();
    this.dlaService.replyMessage(this.messageForm.value.subject, this.messageForm.value.messageBody, this.mail.id).subscribe(
      (data: any) => {
        this.spinner.hide();
        const error: boolean = data.error;
        if (!error) {
          this.alertService.success(data.message);
          this.spinner.hide();
          this.messageForm.reset();
          if (this.type == 'fro') {
            this.router.navigate(['/message']);
          } else {
            this.router.navigate(['/sent']);
          }
          //this.dialogRef.close();
        } else {
          this.spinner.hide();
          this.alertService.danger(data.message);
        }
      },
      error => {
        this.spinner.hide();
        this.alertService.danger('An error occurred, Please try again');
      }
    );
  }

  loadScripts() {
    const dynamicScripts = [
      'assets/js/vendor/jquery-1.11.3.min.js',
      'assets/js/bootstrap.min.js',
      'assets/js/wow.min.js',
      'assets/js/jquery-price-slider.js',
      'assets/js/jquery.meanmenu.js',
      'assets/js/owl.carousel.min.js',
      'assets/js/jquery.sticky.js',
      'assets/js/jquery.scrollUp.min.js',
      'assets/js/scrollbar/jquery.mCustomScrollbar.concat.min.js',
      'assets/js/scrollbar/mCustomScrollbar-active.js',
      'assets/js/metisMenu/metisMenu.min.js',
      'assets/js/metisMenu/metisMenu-active.js',
      'assets/js/summernote/summernote.min.js',
      'assets/js/summernote/summernote-active.js',
      'assets/js/tab.js',
      'assets/js/sparkline/jquery.sparkline.min.js',
      'assets/js/sparkline/jquery.charts-sparkline.js',
      'assets/js/calendar/moment.min.js',
      'assets/js/calendar/fullcalendar.min.js',
      'assets/js/calendar/fullcalendar-active.js',
      'assets/js/plugins.js',
      'assets/js/main.js'
    ];
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < dynamicScripts.length; i++) {
      const node = document.createElement('script');
      node.src = dynamicScripts[i];
      node.type = 'text/javascript';
      node.async = false;
      node.charset = 'utf-8';
      document.getElementsByTagName('head')[0].appendChild(node);
    }
  }


  htmlToText(html) {
    var tmp = document.createElement('DIV'); // TODO: Check if this the way to go with Angular
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
  }
}
